import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "d-lg-flex align-items-center justify-content-between mb-3" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  key: 1,
  class: "flaticon-download lh-1 me-1 position-relative top-2"
}
const _hoisted_11 = { class: "row g-3 pt-4" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "fw-semibold mb-0" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "fw-semibold mb-0" }
const _hoisted_16 = { class: "badge bg-primary-subtle text-primary" }
const _hoisted_17 = { class: "col-md-2" }
const _hoisted_18 = { class: "fw-semibold mb-0" }
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = { class: "fw-semibold mb-0" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "fw-semibold mb-0" }
const _hoisted_23 = { class: "row mt-4" }
const _hoisted_24 = { class: "card shadow-lg border-0 rounded-3 h-100" }
const _hoisted_25 = { class: "card-body d-flex flex-column" }
const _hoisted_26 = { class: "card-title fw-bold text-primary" }
const _hoisted_27 = { class: "text-muted fw-bold small mb-3" }
const _hoisted_28 = { class: "text-muted small mb-3" }
const _hoisted_29 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-0" }, "Informations générales", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: { name: 'ListeEquipagePage', params: { manifestId: _ctx.manifest?.id } },
                  class: "btn btn-success transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Voir l'équipage ", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("button", {
                  class: "btn btn-warning transition border-0 lh-1 fw-medium",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.quitusManifest(_ctx.manifest.id))),
                  disabled: _ctx.isGeneratingQuitus
                }, [
                  (_ctx.isGeneratingQuitus)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                    : (_openBlock(), _createElementBlock("i", _hoisted_10)),
                  _createTextVNode(" " + _toDisplayString(_ctx.isGeneratingQuitus ? 'Génération en cours...' : 'Generer le quitus'), 1)
                ], 8, _hoisted_8),
                _createVNode(_component_router_link, {
                  to: "/liste-manifestes",
                  class: "btn btn-primary transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                    _createTextVNode(" Retour ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Sic Reference", -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.manifest?.sicReference), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Nom du navire", -1)),
                _createElementVNode("p", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.manifest?.navireNom), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Num Imo", -1)),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.manifest?.navireLloyd), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Date d'arrivée", -1)),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.format_Date(_ctx.manifest?.eta)), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Date de dépâts", -1)),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.format_Date(_ctx.manifest?.etd)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h5", _hoisted_26, _toDisplayString(doc.num), 1),
                    _createElementVNode("p", _hoisted_27, " Destinataire : " + _toDisplayString(doc.consigneeName), 1),
                    _createElementVNode("p", _hoisted_28, " NbrMarchandises : " + _toDisplayString(doc.marchandises.length), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-outline-primary mt-auto",
                      onClick: ($event: any) => (_ctx.goToEquipMarchand(doc.id))
                    }, " Voir les détails ", 8, _hoisted_29)
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}